import React, { useEffect, useRef, useState } from "react";
import styles from "../Form.module.scss";

// Uses a custom popover instead of native <select> — macOS native select renders as a dark system popup ignoring theme styling.
function SelectInput({ substep, value, onChange, error, isReadOnly, options = [], onOptionSelect }) {
  const selected = value?.string_value ?? "";
  const selectedOpt = options.find((o) => o.value === selected);

  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState("");
  const wrapRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const onDocClick = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onDocClick);
    return () => document.removeEventListener("mousedown", onDocClick);
  }, [open]);

  const filtered = query
    ? options.filter((o) => o.label.toLowerCase().includes(query.toLowerCase()))
    : options;
  const showSearch = options.length > 0;

  return (
    <div className={styles.fieldBody} ref={wrapRef}>
      <div className={styles.selectWrap}>
        <button
          type="button"
          className={`${styles.selectBtn} ${error ? styles.inputError : ""}`}
          disabled={isReadOnly}
          onClick={() => setOpen((o) => !o)}
          aria-haspopup="listbox"
          aria-expanded={open}
        >
          <span className={selectedOpt ? "" : styles.selectPlaceholder}>
            {selectedOpt ? selectedOpt.label : "Select an option"}
          </span>
          <span
            className={`${styles.selectCaret} ${open ? styles.selectCaretOpen : ""}`}
            aria-hidden="true"
          >
            <svg viewBox="0 0 20 20" fill="none">
              <path
                d="M5 7.5 10 12.5 15 7.5"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </span>
        </button>

        {open && (
          <div className={styles.selectMenu} role="listbox">
            {showSearch && (
              <input
                className={styles.selectSearch}
                type="text"
                placeholder="Search…"
                value={query}
                autoFocus
                onChange={(e) => setQuery(e.target.value)}
              />
            )}
            <div className={styles.selectMenuScroll}>
              {filtered.length === 0 ? (
                <div className={styles.selectEmpty}>No matches</div>
              ) : (
                filtered.map((opt) => {
                  const isSel = opt.value === selected;
                  return (
                    <div
                      key={opt.value}
                      role="option"
                      aria-selected={isSel}
                      className={`${styles.selectItem} ${isSel ? styles.selectItemSel : ""}`}
                      onClick={() => {
                        onChange(substep.substep_id, { string_value: opt.value });
                        onOptionSelect?.(opt);
                        setOpen(false);
                        setQuery("");
                      }}
                    >
                      {opt.label}
                      {isSel && <span className={styles.selectItemTick}>✓</span>}
                    </div>
                  );
                })
              )}
            </div>
          </div>
        )}
      </div>
      {error && <div className={styles.fieldError}>{error}</div>}
    </div>
  );
}

export default SelectInput;
